<app-kpi-widget
  [title]="'executiveStats.widgets.overtimeHours' | transloco"
  [isLoading]="isLoading"
  icon="ph-clock-counter-clockwise"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [totalCost]="cost"
  [costDifference]="difference"
  [dropdownOptions]="dropdownOptions"
  [isUptrendPositive]="isUptrendPositive"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [dropdownEnabled]="false"
  [isImageIcon]="false"
></app-kpi-widget>